import styled from "styled-components";
import PageTemplate from "../../templates/PageTemplate";
import mixins, { media } from "../../../styles/mixins";
import FormTable, { Wrap as FormTableWrap } from "../../organisms/FormTable";
import Button from "../../atoms/Button";
import FormTitle from "../../organisms/FormTitle";
import useDeviceSize from "../../../hooks/useDeviceSize";
import { useApplicationQuery } from "../../../hooks/api/useApplication";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Error from "../../organisms/Error";
import useApplicationFormUitils from "../../../hooks/useApplicationFormUitils";
import FixedFormTable from "../../organisms/FixedFormTable";
import { maskingUserInfo } from "../../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import { useScheduleQuery } from "../../../hooks/api/useSchedule";
import { useTransferredActivityList } from "../../../hooks/api/useActivityTransfer";
import { showAlert } from "../../../reducer/alertSlice";
import Loading from "../../organisms/Loading";
import { DIAMOND_EVENT_IDX } from "../policy/privacyConfig";
import { LOCKED_EVENT_IDX } from "../../../config/eventConfig";

const classNames = require('classnames');

const TextCont = styled.div`
	${mixins.fontStyle("40px", "400", "54.48px")}
	color: #000;
	margin: 40px 0;

	.bold {
		font-weight: 600;
	}

	${media.mobile`
        padding: 40px 20px;
		margin: 0;
        ${mixins.fontStyle("20px", "400", "27.24px")}
    `}
`;

const Wrap = styled.div`

	// mobile
	${media.mobile`
        margin-top: 0;
        .btn-modify {
            margin-top: 60px;
        }
    `}// /mobile
`;

const Section = styled.section`
	& ~ & {
		margin-top: 120px;
	}

	&.abo-information {
		margin-top: 0;

		table {
			th {
				text-align: left;
			}
			tbody {
				td:not(:first-of-type:last-of-type) {
					width: ${(420 / 1200) * 100}%;
				}
			}
		}
	}

	// 액티비티 예약
	&.activity-reservation {
		// table
		table {
			tbody {
				th,
				td {
					border-color: #adadad !important;

					&.empty {
						color: #adadad;
						text-align: center;
					}
				}
				tr {
					td {
						padding: 27px 44px 27px 0;

						.activity-name {
							display: inline-block;
							width: 272px;
							${mixins.fontStyle("18px", "600", "24.52px")}
							color: #000;
						}

						.activity-category {
							display: inline-block;
							${mixins.fontStyle("18px", "400", "24.52px")}
							color: rgba(0, 0, 0, 0.4);
							margin-bottom: 10px;
						}
					}
				}
			}
		}
		// /table
	}
	// 액티비티 예약

	/* 액티비티 양도 */
	&.activity-transfer {
		margin-bottom: 120px;

		${media.mobile`
			margin-bottom: 60px;
		`}

		> .caption {
			${mixins.fontStyle("18px", 700, 1.2)}
			color: #000;
			margin: 0 0 20px;
		}
	}

	${FormTableWrap} {
		// padding-top: 80px;
		overflow: hidden;

		${media.desktop`
            &.pay {
                table {
                    border-top: 4px solid #000;
                    border-bottom: 4px solid #000;
                }
            }
        `}

		// table
        table {
			th,
			td {
				border-color: #adadad;
			}
			tbody {
				td {
					word-wrap: break-word;

					> div {
						overflow: hidden;
						text-overflow: ellipsis;
					}
					&:not(.empty) {
						color: #000;
					}

					&.empty {
						text-align: center;
						height: 360px;
						div {
							display: flex;
							justify-content: center;
							align-items: center;
						}
					}
				}
			}
		}
		// table
	}

	/* mobile */
	${media.mobile`
        ${FormTableWrap} ~ ${FormTableWrap} {
            margin-top: 0;
            
            &::before {
                content: "";
                display: block;
                height: 10px;
                background-color: #E8E8E8;
            }    
        }

        .pay {
            &::before {
                content: "";
                display: block;
                height: 10px;
                background-color: #E8E8E8;
            }  
        }

        // activity-reservation
        &.activity-reservation {
            // FormTableWrap
            ${FormTableWrap} {
                background-color: #F6F6F6;

                &:last-child {
                    border-bottom: 1px solid #ADADAD;
                }

                // table
                table {
                    & ~ table {
                        margin-top: 5px;
                    }
                    th, td {
                        border-bottom: 0 !important;
                        padding-left: 20px !important;
                        padding-right: 20px !important;
                    }

                    th {
                        &::after {
                            background-color: #000;
                        }
                    }

                    thead {
                        th {
                            &::after {
                                width: 100%;
                                left: 0;
                                height: 2px;
                            }
                        }
                    }
                    
                    tbody {
                        tr {
                            position: relative;

                            & ~ .day {
                                border-top: 5px solid #F6F6F6;
                            }

                            &.day {
                                & + tr {
                                    th {
                                        &::before {
                                            background-color: #000;
                                            content: "";
                                            display: block;
                                            position: absolute;
                                            width: calc(100% - 36px);
                                            height: 1px;
                                            top: 0;
                                            left: 18px;
                                        }
                                    }
                                }
                            }
                                
                            th {
                                padding: 18px 0;
                                
                            }

                            td {
                                .activity-category {
                                    ${mixins.fontStyle("14px", "400", "19.07px")}
                                }

                                &:not(.empty) {
                                    &::before {
                                        content: "";
                                        display: block;
                                        position: absolute;
                                        width: calc(100% - 36px);
                                        height: 1px;
                                        top: 0;
                                        left: 18px;
                                        background-color: #ADADAD;
                                    }
                                }
                            }
                        }
                    }
                }    
                // /table
            }
            // /FormTableWrap
        }
        // /activity-reservation

        &.activity-transfer {
            > .caption {
                ${mixins.fontStyle("12px", 400, 1.2, "-0.504px")}
                padding: 0 20px;
                margin: 0 0 10px;
            }

            .activity-transfer-btn-wrap {
                margin: 0;
            }
        }

        ${FormTableWrap} {
            padding-top: 0;
            table {
                thead {
                    th {
                        padding: 30px 14px 20px;
                    }
                }
                th {
                    word-break: keep-all;
                }
            }
        }
    `}/* mobile */
`;

const BtnCont = styled.div`
	display: flex;
	gap: 0 40px;
	justify-content: center;

	&.application-btn-wrap {
		margin-top: 120px;
	}

	button {
		max-width: calc(50% - 20px);
	}

	/* 버튼 1개만 있을 때 (잠금 행사 등) */
	button:only-child {
		max-width: 400px;
	}

	${media.mobile`
        flex-direction: column;
        padding: 0 20px;
        margin: 60px 0;
        gap: 20px 0;

        &.application-btn-wrap {
            margin-top: 0;
			margin-bottom: 0;
        }
        
        button {
            max-width: 100%;
            margin-top: 0;
            margin: 0;
            width: 100%;
        }

        button:only-child {
            margin-top: 40px;
        }
    `}
`;

const ApplicationComplete = () => {
	const { isMobile } = useDeviceSize();
	const { applicationIdx, scheduleIdx } = useParams();

	const applicationQuery = useApplicationQuery({ applicationIdx, scheduleIdx });

	const eventPathStr = sessionStorage.getItem("eventPath");
	const idxParams = eventPathStr ? new URLSearchParams("?" + window.atob(eventPathStr)) : new URLSearchParams();
	const eventIdx = Number(idxParams.get("eventIdx"));
	const isApplicationLocked = eventIdx === LOCKED_EVENT_IDX;

	const [entrepreneurItems, setEntrepreneurItems] = useState();
	const [activityInfo, setActivityInfo] = useState(false);

	const [items3, setItems3] = useState([]);

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const customersInfo = useSelector((state) => state.customers).value;

	const primaryCustomer = customersInfo.filter((v) => v.isPrimary)[0];
	const scheduleQuery = useScheduleQuery(scheduleIdx, primaryCustomer ? primaryCustomer.uid : "");

	const transferredActivityListQuery = useTransferredActivityList(scheduleIdx, primaryCustomer?.uid); // 양도받은 액티비티
	const hasTransferableActivity = transferredActivityListQuery.data?.data?.length > 0;

	/**
	 * 참가자 정보 데이터 가공
	 *
	 * @param {*} users
	 * @return {*}
	 */
	const getInfoTableStructure = (users) => {
		const max = isMobile ? 1 : 2;
		const tableCnt = Math.ceil(users.length / max);

		let dataArray = [];
		let userCnt = 0;

		// table 개수 만큼 반복
		for (let i = 0; i < tableCnt; i++) {
			const userInfo = {
				is_required: "false",
				user: [],
				items: [],
			};

			const category = [];
			for (let j = 0; j < max; j++) {
				// 한 테이블 당 들어가는 유저
				const currentUser = users[userCnt]; // user 신청 정보
				if (currentUser) {
					userInfo["user"].push({
						type_text: currentUser?.type_text,
						is_join: currentUser.fixed_form_value.filter((v) => v.name == "is_join")[0]?.value,
					});

					currentUser?.fixed_form_value.forEach((fixedForm, fixedFormIdx) => {
						const findIdx = category.findIndex((v) => v.name == fixedForm.name);
						// console.log(fixedForm);
						if (fixedForm.is_show == "true") {
							let value = fixedForm.value;
							if (fixedForm.name == "registration_number" || fixedForm.name == "passport_number" || fixedForm.name == "visa_number") {
								value = maskingUserInfo(fixedForm.name, fixedForm.value);
							}
							const valueObj = {
								type_text: currentUser.type_text,
								value: fixedForm.value ? value : "-",
							};
							if (findIdx == -1) {
								category.push({
									is_required: fixedForm.is_required,
									title: fixedForm.title,
									name: fixedForm.name,
									items: [valueObj],
								});
							} else {
								category[findIdx]["items"].push(valueObj);
							}
						}
					});
					userCnt++;
				}
			}
			userInfo.items = category;
			dataArray.push(userInfo); // table
		}

		return dataArray;
	};

	/**
	 * 액티비티 예약 테이블 데이터 가공
	 *
	 * @param {*} users
	 * @param {*} userCountPerTable
	 * @return {*}
	 */
	const getActivityTableStructure = (users) => {
		const max = isMobile ? 1 : 2;
		const tableCnt = Math.ceil(users.length / max);

		let dataArray = [];
		let userCnt = 0;
		// table 개수 만큼 반복
		for (let i = 0; i < tableCnt; i++) {
			const userInfo = {
				user: [],
				items: {},
			};

			for (let j = 0; j < max; j++) {
				// 한 테이블 당 들어가는 유저
				const currentUser = users[userCnt]; // user 신청 정보
				if (currentUser) {
					userInfo["user"].push({
						idx: currentUser.idx,
						type_text: currentUser?.type_text,
						is_join: currentUser.fixed_form_value.filter((v) => v.name == "is_join")[0].value,
					});

					currentUser?.activity.forEach((activityInfo) => {
						// 신청 가능한 액티비티
						const dayStr = "day" + activityInfo.day;
						let selectedActivity = null;

						activityInfo.lists.forEach((myActivity) => {
							if (myActivity.is_select) {
								const findActivityIdx = currentUser.my_activity.findIndex((v) => v.activity_schedule_idx === myActivity.activity_schedule_idx);
								selectedActivity = {
									type_text: currentUser.type_text,
									title: myActivity.title,
									start_time: myActivity.start_time,
									activity_form_value: currentUser.my_activity[findActivityIdx].activity_form_value,
								};
							}
						});
						// console.log(currentUser.type_text + " " +(day+1) + "일차", selectedActivity);

						if (selectedActivity) {
							if (!userInfo.items[dayStr]) {
								// userInfo.items[dayStr] = [];
								userInfo.items[dayStr] = {};
							}
							// userInfo.items[dayStr].push(selectedActivity);
							userInfo.items[dayStr][currentUser.idx] = selectedActivity;
						}
					});

					userCnt++;
				}
			}

			dataArray.push(userInfo); // table
		}
		return dataArray;
	};

	const isMount = useRef(false);
	useEffect(() => {
		if (!isMount.current) {
			applicationQuery.refetch();
			isMount.current = true;
		}
	}, []);

	useEffect(() => {
		if (applicationQuery.data) {
			const tempItems3 = [];
			const tempEntrepreneurItems = {};
			const tempEntrepreneurCategory = [];

			for (const key in applicationQuery.data?.application) {
				const value = applicationQuery.data?.application[key];
				// 액티비티 있을 경우 플래그 true
				if (value.my_activity?.length > 0) {
					setActivityInfo(true);
				}

				if (value.type === 3) {
					tempItems3.push(value);
				} else {
					if (value.type === 1) {
						tempEntrepreneurItems["items1"] = value;
					} else if (value.type === 2) {
						tempEntrepreneurItems["items2"] = value;
					}
					value.fixed_form_value.forEach((el) => {
						if (tempEntrepreneurCategory.findIndex((v) => v.name == el.name) < 0) {
							tempEntrepreneurCategory.push({
								name: el.name,
								title: el.title,
							});
						}
					});
				}

				setEntrepreneurItems(tempEntrepreneurItems);
				setItems3(tempItems3);
			}
		}
	}, [applicationQuery.data]);

	// 접근 제한 모달 — 잠금 행사는 예외
	useEffect(() => {
		if (scheduleQuery.data?.restricted && !isApplicationLocked) {
			dispatch(showAlert({
				msg: scheduleQuery.data.restrictionMessage,
				btnText: "확인",
				func: () => navigate("/", { replace: true })
			}));
		}
	}, [scheduleQuery.data]);

	// 차단된 상태면 빈 로딩화면만 표시 — 잠금 행사는 예외
	if (scheduleQuery.data?.restricted && !isApplicationLocked) {
		return (
			<PageTemplate title="">
				<Loading layer={true}/>
			</PageTemplate>
		);
	}

	if (applicationQuery.data) {
		return (
			<PageTemplate title={`${applicationQuery.data.application[0].title} - ${applicationQuery.data.application[0].order}차수`} showBack={true}>
				<Wrap>

					{/* 액티비티 양도 - 양도 버튼 노출 제어 (기존 조건 AND 시크릿 기간) */}
					{(scheduleQuery.data?.activity_transfer_visible !== undefined
						? scheduleQuery.data.activity_transfer_visible
						: (scheduleQuery.data?.target == "activity" && Number(scheduleQuery.data?.activity_transfer_enabled) === 1)
					) && (
						<Section className="activity-transfer">
							<div className="caption">* 특정 액티비티의 신청 횟수를 양도/양수 할 수 있습니다.</div>
							<BtnCont className="activity-transfer-btn-wrap">
								<Button
									type="button"
									$bg="dark"
									onClick={() => {
										navigate("/application/" + applicationQuery.data.information.url_path + "/activityTransfer");
									}}>
									액티비티 양도/양수하기
									{hasTransferableActivity && <div className="transfer-tooltip">양도받을 액티비티 횟수가 있어요</div>}
								</Button>
							</BtnCont>
						</Section>
					)}

					{/* 신청 내용 */}
					<FormTitle>신청 내용</FormTitle>
					<TextCont>
						<p className="bold">신청이 완료되었습니다.</p>
						<p>아래 신청 내용을 확인해주세요.</p>
					</TextCont>

					{
						<Section className="abo-information">
							{
								<>
									{entrepreneurItems && <RenderInfoTable keyName="entrepreneur" data={getInfoTableStructure([entrepreneurItems["items1"], entrepreneurItems["items2"]])} />}

									{items3.length > 0 && <RenderInfoTable keyName="item3" data={getInfoTableStructure(items3)} />}
								</>
							}

							{/* 공통항목 */}
							{Object.keys(applicationQuery.data.payment).length > 0 && (
								<FixedFormTable className="pay">
									<thead></thead>
									<tbody>
										<tr>
											<th className="required">
												<span>결제방식 선택</span>
											</th>
											<td>{applicationQuery.data.payment.payment_type ? applicationQuery.data.payment.payment_type : "-"}</td>
										</tr>
										<tr>
											{applicationQuery.data.payment.payment_type === "카드" && (
												<>
													<th className="required">
														<span>결제 수신자 핸드폰번호</span>
													</th>
													<td>{applicationQuery.data.payment.payment_phone}</td>
												</>
											)}
											{applicationQuery.data.payment.payment_type === "계좌이체" && (
												<>
													<th className="required">
														<span>입금자명</span>
													</th>
													<td>{applicationQuery.data.payment.payment_name}</td>
												</>
											)}
										</tr>
									</tbody>
								</FixedFormTable>
							)}
						</Section>
					}

					{/* 액티비티 예약 */}
					{activityInfo && (
						<Section className="activity-reservation">
							<FormTitle>{eventIdx === DIAMOND_EVENT_IDX ? '액티비티 및 항공 일정 예약' : '액티비티 예약'}</FormTitle>

							{
								<>
									{/* 주사업자/부사업자 액티비티 예약 */}
									{entrepreneurItems && <RenderActivityTable keyName="entrepreneur" data={getActivityTableStructure([entrepreneurItems["items1"], entrepreneurItems["items2"]])} eventIdx={eventIdx} />}

									{/* 동반가족 액티비티 예약 */}
									{items3.length > 0 && <RenderActivityTable keyName="items3" data={getActivityTableStructure(items3)} eventIdx={eventIdx} />}
								</>
							}
						</Section>
					)}

					<BtnCont className="application-btn-wrap">
						{/* 잠금 행사면 1차 신청 수정 버튼 미노출 */}
						{!isApplicationLocked && (
							<Button
								type="button"
								className="btn-modify"
								onClick={() => {
									navigate("/application/" + applicationQuery.data.information.url_path + "/modify");
								}}>
								신청 정보 수정하기
							</Button>
						)}
						{scheduleQuery.data?.target == "activity" && (
							<Button
								type="button"
								$bg="dark"
								onClick={() => {
									navigate("/application/" + applicationQuery.data.information.url_path + "/activity");
								}}>
								액티비티 선택(수정)하기
							</Button>
						)}
					</BtnCont>


				</Wrap>
			</PageTemplate>
		);
	}

	if (applicationQuery.isLoading || applicationQuery.isFetching) {
		return (
			<PageTemplate>
				<Error error={false} msg="잠시만 기다려 주세요..." />
			</PageTemplate>
		);
	}

	if (applicationQuery.isError) {
		return (
			<PageTemplate>
				<Error msg={applicationQuery.error?.response?.data?.msg?.ko} />
			</PageTemplate>
		);
	}
};

/**
 * 액티비티 예약 테이블 그리기
 *
 * @param {*} data
 * @return {*}
 */
const RenderActivityTable = ({ data, keyName = "", eventIdx }) => {
	const { isMobile } = useDeviceSize();

	const getRowspan = (type) => {
		let result = 0;
		let i = 0;
		for (const key in type) {
			const userList = type[key];
			let criteria = userList[Object.keys(userList)[0]];
			if (Object.keys(userList).length == 2 && userList[Object.keys(userList)[0]] < userList[Object.keys(userList)[1]]) {
				criteria = userList[Object.keys(userList)[1]];
			}
			result += criteria.activity_form_value.length + 1;
			i++;
		}

		return result ? result : 1;
	};

	return data?.map((type, tableIdx) => {
		const rowspan = isMobile ? 1 : getRowspan(type.items);
		return (
			<FormTable key={`activity_table_${keyName}_${tableIdx}`}>
				<colgroup>
					{!isMobile && (
						<>
							<col style={{ width: "120px" }} />
							<col />
							<col style={{ width: "45%" }} />
						</>
					)}
				</colgroup>
				<thead>
					<tr>
						{!isMobile && <td></td>}
						{type.user.map((user) => {
							return (
								<th key={`activity_${user.type_text}`} colSpan={isMobile ? 2 : 1}>
									{user.type_text}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{
						// 해당 테이블의 신청 정보 없는 경우
						Object.keys(type.items).length == 0 ? (
							<tr>
								{!isMobile && <td></td>}
								{type.user.map((user) => {
									return (
										<td className="empty" key={`activity_empty_${user.idx}`} colSpan={isMobile ? 2 : 1}>
											정보 없음
										</td>
									);
								})}
							</tr>
						) : (
							Object.keys(type.items)
								?.sort((a, b) => {
									// "day" 뒤의 숫자를 추출하여 숫자로 변환
									const numA = parseInt(a.replace("day", ""), 10);
									const numB = parseInt(b.replace("day", ""), 10);
									return numA - numB; // 숫자를 기준으로 정렬
								})
								?.map((day, dayIdx) => {
									const userList = type.items[day];

									const firstUserKey = Object.keys(userList)[0];
									const secondUserKey = Object.keys(userList)[1];
									let criteria = userList[firstUserKey];
									if (Object.keys(userList).length == 2 && userList[firstUserKey].activity_form_value.length < userList[secondUserKey].activity_form_value.length) {
										criteria = userList[secondUserKey];
									}

									if (Object.keys(userList).length > 0) {
										// 액티비티 정보 있는 날만
										let isJoin;
										if (isMobile) {
											isJoin = type["user"].filter((v) => v.type_text == userList[firstUserKey].type_text)[0].is_join;
										}

										return (
											<React.Fragment key={`activity_${tableIdx}_${day}`}>
												{isMobile && isJoin == "참여" && (
													<tr className="day">
														<th colSpan={2}>
															{eventIdx === DIAMOND_EVENT_IDX && day === 'day1' ? (
																<span>항공일정</span>
															) : (
																day.toUpperCase()
															)}
														</th>
													</tr>
												)}
												{
													<tr>
														{
															/* day */
															!isMobile && <th rowSpan={criteria?.activity_form_value?.length ? criteria.activity_form_value.length + 1 : 1}>
																{eventIdx === DIAMOND_EVENT_IDX && day === 'day1' ? (
																	<span>항공일정</span>
																) : (
																	day.toUpperCase()
																)}
															</th>
														}

														{
															/* 선택 액티비티 타이틀 (시작 시간) */
															type.user.map((userItem, userCnt) => {
																const myActivity = userList[userItem.idx];
																const isJoin = userItem.is_join;
																if (isJoin == "참여") {
																	if (!myActivity) {
																		return (
																			<th key={`activity_none_${userCnt}`} className="empty" rowSpan={!myActivity ? (isMobile ? 2 : 2) : undefined}>
																				정보 없음
																			</th>
																		);
																	} else {
																		return (
																			<th key={`activity_selected_${type.user[userCnt].type_text}_${myActivity?.title}`} colSpan={isMobile ? 2 : 1}>
																				{myActivity?.title} {myActivity?.start_time && `(${myActivity?.start_time})`}
																			</th>
																		);
																	}
																} else {
																	return (
																		dayIdx === 0 && (
																			<td key={`activity_empty_${day}_${userCnt}`} className="empty" rowSpan={rowspan} colSpan={isMobile ? 2 : 1}>
																				<div>정보 없음</div>
																			</td>
																		)
																	);
																}
															})
														}
													</tr>
												}
												{
													// 선택 액티비티 상세 항목
													criteria?.activity_form_value?.map((criteriaForm, formIdx) => {
														return (
															<tr key={`my_activity_${tableIdx}_${day}_${formIdx}`}>
																{Object.keys(userList)?.map((userIdx, myActivityIdx) => {
																	const myActivity = userList[userIdx];
																	const isJoin = type["user"].filter((v) => v.type_text == myActivity.type_text)[0].is_join;
																	const formInfo = myActivity.activity_form_value[formIdx];
																	if (isJoin === "참여") {
																		return formInfo ? (
																			<td key={`my_activity_${tableIdx}_${day}_${myActivityIdx}_${userIdx}_${formIdx}`} colSpan={isMobile ? 2 : 1}>
																				<div className="activity-category">
																					{formInfo.title?.split("\n").map((el, activityCategoryCnt) => (
																						<React.Fragment key={`activity_category_${activityCategoryCnt}`}>
																							{el}
																							<br />
																						</React.Fragment>
																					))}
																				</div>
																				<div>{(!formInfo || !formInfo?.value || formInfo?.value == "false") && formInfo?.value !== 0 ? "-" : formInfo?.value?.toString()}</div>
																			</td>
																		) : (
																			<td key={`my_activity_${tableIdx}_${day}_${myActivityIdx}_${userIdx}_${formIdx}_none`} colSpan={isMobile ? 2 : 1}>
																				<div>-</div>
																			</td>
																		);
																	}
																})}
															</tr>
														);
													})
												}
											</React.Fragment>
										);
									}
								})
						)
					}
				</tbody>
			</FormTable>
		);
	});
};

/**
 * 참가자 정보 테이블 그리기
 *
 * @param {*} data
 * @return {*}
 */
const RenderInfoTable = ({ data, keyName = "" }) => {
	const { isMobile } = useDeviceSize();
	const { getCategoryDescription } = useApplicationFormUitils();
	const customersInfo = useSelector((state) => state.customers).value;

	return data?.map((table, tableCnt) => {
		return (
			<FixedFormTable key={`${keyName}_table_${tableCnt}`}>
				<thead>
					<tr>
						{!isMobile && <td></td>}
						{table.user.map((user) => {
							return (
								<th key={`info_type_text_${user.type_text}`} colSpan={isMobile ? 2 : 1}>
									{user.type_text}
								</th>
							);
						})}
					</tr>
				</thead>

				<tbody>
					{table.items?.map((category, categoryIdx) => {
						const description = getCategoryDescription(category.name);
						let isColumn = false;
						if (category.name === "allergy") {
							isColumn = true;
						}

						// 안내 이미지 항목 제외
						// 공동 사업자일 때 비사업배우자 참가신청서 제외
						let isDrawForMo = false;
						if (category.name !== "family_guide_attachment" && !(category.name === "join_attachment" && customersInfo.length === 2)) {
							if (isMobile) {
								return (
									<React.Fragment key={`mobile_item_table_${category.name}_${categoryIdx}`}>
										<tr className={description ? "border-none" : ""}>
											{table.user[0].is_join === "불참" ? null : (
												<th colSpan={isColumn ? 2 : 1} className={classNames({
													"required": category.is_required == "true",
												})}>
													<span>
														{
														(isMobile && category.name == "registration_number") ?
														<>주민등록번호/<br/>외국인등록번호</>
														:
														category.title
														}
													</span>
												</th>
											)}

											{!isColumn &&
												table.user.map((user, userCnt) => {
													if (category.name === "is_join") {
														if (user.is_join === "불참" || !user.is_join) {
															if (!isDrawForMo) {
																isDrawForMo = true;
																return (
																	<td key={`user_none_${userCnt}`} className="empty" colSpan={2} rowSpan={table.items.length}>
																		정보 없음
																	</td>
																);
															}
														}
													}
													if (user.is_join == "참여") {
														return (
															<td key={`mobile_value_${keyName}_${tableCnt}_${categoryIdx}_${userCnt}`}>
																{category.items?.map((value, valueIdx) => {
																	if (user.type_text == value.type_text) {
																		return <React.Fragment key={`mobile_cat_${categoryIdx}_${valueIdx}`}>{value.value}</React.Fragment>;
																	}
																})}
															</td>
														);
													}
												})}
										</tr>
										{table.user[0].is_join !== "불참" && (
											<>
												{isColumn && (
													<tr className="border-none">
														<td colSpan={2}>{category.items[0].value}</td>
													</tr>
												)}
												{description && table.user[0].is_join === "참여" && (
													<tr className="desc">
														<td colSpan={2}>{description}</td>
													</tr>
												)}
											</>
										)}
									</React.Fragment>
								);
							} else {
								return (
									<tr key={`pc_item_table_${category.name}_${categoryIdx}`}>
										{
											<th className={category.is_required == "true" ? "required" : ""}>
												<span>{category.title}</span>

												{description}
											</th>
										}

										{table.user.map((user, userCnt) => {
											if (category.name === "is_join") {
												if (user.is_join === "불참" || !user.is_join) {
													return (
														<td key={`user_none_${userCnt}`} className="empty" rowSpan={table.items.length}>
															정보 없음
														</td>
													);
												}
											}

											if (user.is_join == "참여") {
												return (
													<td key={`join_user_${userCnt}`}>
														{category.items?.map((value, valueIdx) => {
															if (user.type_text == value.type_text) {
																if (typeof value.value == "string") {
																	return <React.Fragment key={`pc_cat_${categoryIdx}_${valueIdx}`}>{value?.value}</React.Fragment>;
																} else {
																	if (value?.value?.value) {
																		return <React.Fragment key={`pc_cat_${categoryIdx}_${valueIdx}`}>{value?.value?.value}</React.Fragment>;
																	} else {
																		return <React.Fragment key={`pc_cat_${categoryIdx}_${valueIdx}`}>{value?.value?.toString()}</React.Fragment>;
																	}
																}
															}
														})}
													</td>
												);
											}
										})}
									</tr>
								);
							}
						}
					})}
				</tbody>
			</FixedFormTable>
		);
	});
};
export default ApplicationComplete;
